export interface Subscription {
  member: string
  store: string
  product: string
  productId: string
  base: string
  offer: string
  status: string
  paidAt: string
  next: string
  dday: string
  packageType: string
  renew: string
  checked: string
}

export const subscriptions: Subscription[] = [
  { member: '김영숙', store: 'Google Play', product: '플러스 월간', productId: 'plus.monthly', base: 'monthly-auto', offer: 'trial-7d', status: '구독 중', paidAt: '2026-07-27', next: '2026-08-27', dday: 'D-30', packageType: '통합 패키지', renew: 'ON', checked: '09:42' },
  { member: '박춘자', store: 'Google Play', product: '드러머 월간', productId: 'drummer.monthly', base: 'monthly-auto', offer: '-', status: '무료 체험 중', paidAt: '2026-07-03', next: '2026-08-03', dday: 'D-6', packageType: '드럼 전용', renew: 'ON', checked: '09:38' },
  { member: '이문호', store: 'App Store (추후 적용)', product: '인지 월간', productId: 'cognitive.monthly', base: 'monthly-auto', offer: '-', status: '화면 구성', paidAt: '-', next: '-', dday: '-', packageType: '인지 전용', renew: '-', checked: '연동 예정' },
  { member: '정기태', store: 'App Store (추후 적용)', product: '플러스 월간', productId: 'plus.monthly', base: 'monthly-auto', offer: 'welcome', status: '화면 구성', paidAt: '-', next: '-', dday: '-', packageType: '통합 패키지', renew: '-', checked: '연동 예정' },
]

export interface Payment {
  order: string
  member: string
  product: string
  amount: string
  type: string
  status: string
  ack: string
  refund: string
  paidAt: string
}

export const payments: Payment[] = [
  { order: 'GPA.3381-8841-1182', member: '김영숙', product: '플러스 월간', amount: 'KRW 14,900', type: '자동 갱신', status: '완료', ack: '승인 완료', refund: '-', paidAt: '2026-07-27' },
  { order: 'GPA.8821-5541-6204', member: '박춘자', product: '드러머 월간', amount: 'KRW 8,900', type: '최초 결제', status: '무료 체험', ack: '승인 완료', refund: '-', paidAt: '2026-07-03' },
  { order: 'GPA.6602-1184-0192', member: '이문호', product: '인지 월간', amount: 'KRW 8,900', type: '자동 갱신', status: '결제 실패', ack: '검토중', refund: '-', paidAt: '2026-07-28' },
]

export interface Product {
  name: string
  id: string
  base: string
  offer: string
  grade: string
  rights: string
  sale: string
  amount: string
}

export const products: Product[] = [
  { name: '드러머 월간', id: 'drummer.monthly', base: 'monthly-auto', offer: 'trial-7d', grade: '드러머', rights: '드럼', sale: '판매중', amount: '8,900' },
  { name: '인지 월간', id: 'cognitive.monthly', base: 'monthly-auto', offer: 'trial-7d', grade: '인지', rights: '인지', sale: '판매중', amount: '8,900' },
  { name: '플러스 월간', id: 'plus.monthly', base: 'monthly-auto', offer: 'welcome', grade: '플러스', rights: '드럼+인지', sale: '판매중', amount: '14,900' },
]

export type IssueType = 'warning' | 'danger' | 'primary'

export interface Issue {
  title: string
  desc: string
  type: IssueType
}

export const paymentIssues: Issue[] = [
  { title: 'Google 상태와 내부 등급 불일치', desc: '4명의 회원 권한을 재동기화해야 합니다.', type: 'warning' },
  { title: '구매 토큰 검증 실패', desc: '인지 월간 1건이 Developer API 확인 실패 상태입니다.', type: 'danger' },
  { title: '필수 난이도 등록 현황', desc: '모든 악보가 3개 난이도 등록 기준으로 관리됩니다.', type: 'primary' },
]

export const subscriptionsSpecification = {
  title: '구독관리',
  purpose: '스토어 구독, 상품 구성, 결제 내역을 확인하는 운영 화면입니다.',
  functions: [
    '회원·기간 검색으로 구독과 결제 기록을 조회합니다.',
    '상품별 판매 상태와 드럼·인지 이용 권한을 관리합니다.',
    'App Store 항목은 현재 화면 구성용이며 실제 결제 검증 연동은 추후 적용합니다.',
  ],
  connections: [
    '회원관리의 결제내역 확인하기와 연결됩니다.',
    '설정의 등급 및 권한 설정은 상품별 접근 범위와 함께 검토합니다.',
  ],
  app: '현재 Google Play 결제 상태가 사용자 앱의 유료 구독 권한과 드럼·인지 콘텐츠 접근을 결정합니다. iOS 구독은 추후 동일한 상품·권한 정책으로 연동합니다.',
}

export const subscriptionsDataModelGuide = [
  '구독 키: subscription_id, 결제 키: payment_id, 회원 연결 키: member_id',
  '필수 속성: store, product_id, base_plan, offer_id, 결제·갱신 상태, 권한 시작·종료 시각',
  'Google Play은 실제 검증 대상이며 App Store는 현재 화면 구성 상태입니다.',
]

export const subscriptionsImplementationGuide = [
  '화면 식별자: subscriptions. 좌측 사이드 메뉴는 유지하고 메인 영역만 전환합니다.',
  '필수 데이터: 스토어, 상품 ID, 결제·갱신 상태, 결제일, 다음 갱신일, 제공 권한.',
  '회원 검색과 기간 조건은 구독 목록과 결제 목록에 각각 적용합니다.',
  '상품 상태 변경은 신규 판매 가능 여부만 바꾸며, 기존 구독자 권한 이력은 보존합니다.',
  '현재 화면은 운영 UI 목업입니다. 실제 개발에서는 API 응답, 저장 성공·실패, 권한 오류, 빈 목록 상태를 별도로 구현해야 합니다.',
]

export const subscriptionsStateDefinitions: [string, string, string][] = [
  ['구독 중', '결제 검증 완료', '해당 상품의 유료 권한 활성화'],
  ['무료 체험 중', '체험 기간 유효', '종료일까지 해당 상품 권한 활성화'],
  ['해지 예정', '자동 갱신만 중지', '다음 결제일 전까지 기존 권한 유지'],
  ['미구독', '유료 권한 없음', '무료 이용 범위만 접근'],
  ['화면 구성 / 연동 예정', 'iOS 시각 화면만 구성', '실제 결제 검증과 권한 부여는 실행하지 않음'],
]
